<template>
  <nav class="gd-nav">
    <div class="container gd-nav-inner">
      <router-link :to="{ name: hubName }" class="gd-nav-back">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M10.733 19.79a.75.75 0 0 0 1.06-1.06l-5.58-5.58H20.25a.75.75 0 0 0 0-1.5H6.213l5.58-5.58a.75.75 0 1 0-1.06-1.06L3.925 11.276a.75.75 0 0 0 0 1.062l6.808 7.452z" fill="currentColor"/>
        </svg>
        <span>সব গাইডলাইন</span>
      </router-link>

      <div class="gd-nav-pills">
        <button
          v-for="g in guidelines"
          :key="g.key"
          class="gd-pill"
          :class="{ active: g.key === current }"
          :aria-current="g.key === current ? 'page' : null"
          @click="go(g)"
        >
          {{ g.short }}
          <span class="gd-pill-mark">{{ g.marks }}</span>
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import { useRouter } from 'vue-router';
import { guidelines, guidelinesHubName } from "@/components/WelcomePages/guidelinesData";

export default {
  name: 'GuidelineNav',
  props: {
    current: { type: String, required: true },
  },
  setup(props) {
    const router = useRouter();
    const go = (g) => {
      // current pill is not a navigation target
      if (g.key === props.current) return;
      router.push({ name: g.route });
    };
    return { guidelines, hubName: guidelinesHubName, go };
  },
};
</script>

<style scoped>
* { box-sizing: border-box; }

.gd-nav {
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 2px 10px rgba(25, 27, 71, 0.04);
}
.gd-nav-inner {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  column-gap: 12px;
  min-height: 58px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.gd-nav-back {
  grid-column: 1;
  justify-self: start;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #64748b;
  text-decoration: none;
  transition: color 0.18s;
}
.gd-nav-back:hover { color: #191B47; }

.gd-nav-pills {
  grid-column: 2;
  justify-self: center;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.gd-nav-pills::-webkit-scrollbar { display: none; }

.gd-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
  background: #f1f5f9;
  border: 1.5px solid #e2e8f0;
  border-radius: 999px;
  padding: 7px 16px;
  font-size: 0.86rem;
  font-weight: 700;
  color: #475569;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.18s;
}
.gd-pill:hover { border-color: #0095FF; color: #191B47; }
.gd-pill.active {
  background: #191B47;
  border-color: #191B47;
  color: #fff;
  cursor: default;
  box-shadow: 0 4px 14px rgba(25, 27, 71, 0.25);
}
.gd-pill-mark {
  font-size: 0.66rem;
  font-weight: 800;
  background: rgba(25, 27, 71, 0.08);
  color: #191B47;
  padding: 2px 8px;
  border-radius: 999px;
}
.gd-pill.active .gd-pill-mark {
  background: rgba(0, 149, 255, 0.18);
  color: #0095FF;
}
.gd-pill:hover .gd-pill-mark { background: rgba(25, 27, 71, 0.12); }

@media (max-width: 640px) {
  .gd-nav-inner {
    grid-template-columns: 1fr;
    row-gap: 8px;
    min-height: 0;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .gd-nav-back { grid-column: 1; }
  .gd-nav-pills {
    grid-column: 1;
    justify-self: stretch;
    justify-content: flex-start;
  }
  .gd-pill { padding: 6px 12px; font-size: 0.8rem; }
  .gd-pill-mark { display: none; }
}
</style>